import SearchIcon from "../images/SearchIcon.mjs";

/**
 * App icon for setting/properties action
 * @see {GlyphIcon}
 * @see {SearchIcon}
 */
const AppSearchIcon = class extends SearchIcon {}

export default AppSearchIcon;